import type { Locale } from "../translations";

export const newsCategories = ["company", "events", "applications", "gallery"] as const;
export type NewsCategory = (typeof newsCategories)[number];
export interface NewsSpan { text: string; marks: string[] }
export interface NewsBlock {
  key: string;
  style: "normal" | "h2" | "h3" | "blockquote";
  list: "bullet" | "number" | null;
  children: NewsSpan[];
  links: Record<string, string>;
}
export interface NewsTranslation {
  language: Locale;
  title: string;
  excerpt: string;
  body: NewsBlock[];
  seoTitle?: string;
  seoDescription?: string;
}
export interface NewsImage {
  url: string;
  width: number;
  height: number;
  alt: Partial<Record<Locale, string>>;
  caption: Partial<Record<Locale, string>>;
}
export interface NewsArticle {
  id: string;
  slug: string;
  category: NewsCategory;
  publishedAt: string;
  updatedAt: string;
  featured: boolean;
  cover: NewsImage;
  gallery: NewsImage[];
  translations: NewsTranslation[];
}
export interface NewsSnapshot {
  schemaVersion: 1;
  source: "unconfigured" | "sanity";
  syncedAt: string | null;
  articles: NewsArticle[];
}
export type NewsCardData = Pick<NewsArticle,"id"|"slug"|"category"|"publishedAt"|"cover"> & {
  translations: Pick<NewsTranslation,"language"|"title"|"excerpt">[];
};
